module.exports = __webpack_public_path__ + "static/media/followButton.e2b4fabb.svg";